import type { EntityId } from '@reduxjs/toolkit';

import type { FileEntity } from '../interfaces/files.interface';

const fileItems: FileEntity[] = [];

const entities: Record<string, FileEntity> = {};

fileItems.forEach(item => (entities[item.id] = { ...item }));

const ids = Object.keys(entities) as EntityId[];

export const selected: EntityId[] = [];

export const filesData = { ids, entities, selected };
